'use client'

import SoundCloudPlayer from 'react-player/soundcloud'

export type HgSoundCloudEmbedProps = {
  url: string
}

export const HgSoundCloudEmbed = ({url}: HgSoundCloudEmbedProps) => (
  <SoundCloudPlayer data-chromatic="ignore" url={url} width="100%" height="450" />
)
